import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { SettingsData, PrivateBlock } from '../types/types';
import PrintPrivateEvents from '../components/PrintPrivateEvents';

const PrivateEvents: React.FC = () => {
  const [privateBlocks, setPrivateBlocks] = useState<PrivateBlock[]>([]);
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { currentUser, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
      return;
    }

    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }

    fetchPrivateEvents();
  }, [currentUser, isAdmin, navigate]);

  const fetchPrivateEvents = async () => {
    try {
      setLoading(true);
      const settingsDoc = await getDoc(doc(db, 'settings', 'bookings'));

      if (settingsDoc.exists()) {
        const settingsData = settingsDoc.data() as Partial<SettingsData>;
        setPrivateBlocks(settingsData.privateBlocks || []);
      }
    } catch (error) {
      console.error('Hiba a zártkörű események lekérése során:', error);
    } finally {
      setLoading(false);
    }
  };

  // Mobil menü megnyitása/bezárása
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  if (!currentUser || !isAdmin) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation showPublicBooking={true} />

      <div className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">Zártkörű események kezelése</h1>

          <div className="bg-white overflow-hidden shadow-sm rounded-lg">
            <div className="p-6 bg-white border-b border-gray-200">
              {loading ? (
                <div className="text-center py-4">
                  <p className="text-gray-600">Zártkörű események betöltése...</p>
                </div>
              ) : (
                <div>
                  <div className="mb-6">
                    <p className="text-gray-600">
                      Ezen az oldalon megtekintheted és kinyomtathatod a rendszerben rögzített zártkörű eseményeket.
                      A zártkörű események hozzáadása vagy módosítása a <a href="/settings" className="text-blue-600 hover:underline">Beállítások</a> oldalon lehetséges.
                    </p>
                  </div>

                  {privateBlocks.length === 0 ? (
                    <div className="text-center py-8 bg-gray-50 rounded-lg">
                      <p className="text-gray-600">Nincsenek zártkörű események beállítva a rendszerben.</p>
                      <a 
                        href="/settings" 
                        className="mt-4 inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                      >
                        Zártkörű események hozzáadása
                      </a>
                    </div>
                  ) : (
                    <PrintPrivateEvents privateBlocks={privateBlocks} />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateEvents; 